import BaseService from '../BaseService.js'

export default class AdminService extends BaseService {

  constructor() {
    super('admin')
  }

  async updateList(object, serviceName) {
    await this.retrieveBackendUrl()
    const url = (serviceName) ? `${this.backendUrl}/${serviceName}` : this.backendUrl
    return this.checkError(
      fetch(`${url}`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(object)
      })
    )
  }
}
